export class MyInsuranceBaseError extends Error {
  constructor(message: string, originalError?: Error) {
    super(message);

    if (originalError) {
      this.stack = originalError.stack;
    }
  }
}
